/* =============================================================================
   Rynoka — Image guard (behaviour layer)

   Partner to assets/toyland-image-guard.css. Blocks the three gestures that
   save an image without opening developer tools:

     right-click → "Save image as…"      contextmenu
     long-press on Android → "Download"  contextmenu (same event)
     drag onto the desktop / another tab dragstart

   iOS Safari's long-press sheet has no contextmenu event; it is suppressed by
   `-webkit-touch-callout: none` in the stylesheet.

   Delegated on `document` so it also covers markup this theme never renders —
   Judge.me review photos, Instafeed tiles, anything an app injects later — and
   so no section has to opt in.

   None of this stops a determined visitor. The Network panel, "View source"
   and a plain `curl` of the cdn.shopify.com URL all still work, and always
   will. docs/IMAGE_PROTECTION.md spells out the boundary.

   Gated on `html[data-tl-imgguard="on"]`, written by layout/theme.liquid from
   the "Rynoka — Image protection" theme setting.
   ============================================================================= */
(function () {
  'use strict';

  var root = document.documentElement;
  if (!root || root.getAttribute('data-tl-imgguard') !== 'on') return;

  /* Raster media only. Inline <svg> is excluded on purpose: browsers offer no
     "Save image as…" for it, and our icons live inside links and buttons whose
     right-click menu shoppers still use. `[data-tl-guard]` is the escape hatch
     for a wrapper that paints its image via background-image — those have no
     image entries in the menu today, but marking one costs nothing. */
  var MEDIA_SELECTOR = 'img, picture, canvas, video, [data-tl-guard]';

  function isGuarded(node) {
    return !!(node && node.closest && node.closest(MEDIA_SELECTOR));
  }

  /* Capture phase on both listeners: a section that calls stopPropagation on
     its own gallery must not be able to leave a photo unguarded. */
  document.addEventListener(
    'contextmenu',
    function (e) {
      if (isGuarded(e.target)) e.preventDefault();
    },
    true
  );

  document.addEventListener(
    'dragstart',
    function (e) {
      if (isGuarded(e.target)) e.preventDefault();
    },
    true
  );

  /* ─── Optional: swallow the devtools shortcuts ──────────────────────────────
     Off unless the merchant ticks "Also block developer-tool shortcuts". It is
     deliberately not the default — the same panels open from the browser's own
     ⋮ menu, `view-source:` still resolves, and every one of these chords has a
     legitimate keyboard-only use. Treat it as friction for the incurious, not
     as protection, and read the setting's warning before turning it on. */
  if (root.getAttribute('data-tl-imgguard-keys') === 'on') {
    document.addEventListener('keydown', function (e) {
      var key = (e.key || '').toLowerCase();
      var mod = e.ctrlKey || e.metaKey;
      var matched =
        e.key === 'F12' ||
        (mod && e.shiftKey && (key === 'i' || key === 'j' || key === 'c')) ||
        (mod && (key === 'u' || key === 's'));
      if (!matched) return;

      /* Never swallow a chord aimed at a form field — a shopper typing an
         address must keep every editing shortcut the browser gives them. */
      var t = e.target;
      if (
        t &&
        t.closest &&
        t.closest('input, textarea, select, [contenteditable="true"]')
      ) {
        return;
      }

      e.preventDefault();
    });
  }
})();
